import React from "react";
import { getTableColumnPreferenceKey } from "helpers/GeneralHelper";

/**
 * Manage Columns checkboxes — `defaultChecked` + remount key from `keyName` / accessor.
 */
const ManageColumnsModalFields = ({
    columns = [],
    columnOrder = [],
    orderedColumns,
    visibleColumns = {},
    onToggle,
    tableKey = "table",
    showColumnModal = false,
}) => {
    const columnsToRender =
        Array.isArray(orderedColumns) && orderedColumns.length
            ? orderedColumns
            : Array.isArray(columns)
              ? columns
              : [];

    return (
        <div
            key={
                showColumnModal
                    ? `manage-columns-open-${tableKey}`
                    : `manage-columns-closed-${tableKey}`
            }
        >
            {columnsToRender.map((columnDefinition) => {
                const columnKey = getTableColumnPreferenceKey(columnDefinition);
                if (!columnKey) return null;
                const isChecked = Boolean(visibleColumns[columnKey]);
                const checkboxInputId = `manage-col-${tableKey}-${columnKey}`;
                return (
                    <div key={columnKey} className="d-flex align-items-center mb-2">
                        <input
                            type="checkbox"
                            className="form-check-input me-2"
                            id={checkboxInputId}
                            name={columnKey}
                            key={`${checkboxInputId}-${isChecked}-${showColumnModal}`}
                            defaultChecked={isChecked}
                            onChange={() => onToggle?.(columnKey)}
                        />
                        <label className="form-check-label" htmlFor={checkboxInputId}>
                            {columnDefinition?.Header}
                        </label>
                    </div>
                );
            })}
        </div>
    );
};

export default ManageColumnsModalFields;
